import React, { Fragment } from 'react'
import CardEmpty from "Utils/Cards/CardEmpty";
import { currencyValue, kgValue } from '../../../Utils/renderField/hookForms';

/**
 * Componente para mostrar los datos de bonificación.
 * @param {object} props - Props del componente.
 * @param {object} props.item - Objeto que contiene los datos de la finca.
 * @returns {JSX.Element} - Componente de datos de bonificación.
 */
const DatosBonificacion = (props) => {
    const { item } = props;

    const historial_amoniaco = item.historial_amoniaco ? item.historial_amoniaco : [];
    const historial_bonif_fletes = item.historial_bonif_fletes ? item.historial_bonif_fletes : [];

    let configBonifAmoniaco = {
        valor_limite_nh3: 'NO CONFIGURADO',
        bono_por_kilogramo: 'NO CONFIGURADO',
    }

    let configBonifFletes = {
        bonif_fletes_min_kg: 'NO CONFIGURADO',
        bonif_fletes_bono_por_kg: 'NO CONFIGURADO',
    }

    if (historial_amoniaco.length > 0) {
        const configVigente = historial_amoniaco[historial_amoniaco.length - 1];
        configBonifAmoniaco = {
            valor_limite_nh3: configVigente.valor_limite_nh3,
            bono_por_kilogramo: configVigente.bono_por_kilogramo,
        }
    }

    if (historial_bonif_fletes.length > 0) {
        const configVigente = historial_bonif_fletes[historial_bonif_fletes.length - 1];
        configBonifFletes = {
            bonif_fletes_min_kg: configVigente.bonif_fletes_min_kg,
            bonif_fletes_bono_por_kg: configVigente.bonif_fletes_bono_por_kg,
        }
    }

    return (
        <div className="mt-3">
            <CardEmpty noShadow>
                <div className="formulario-fields-row mt-0">
                    {/* BONIFICACION POR USO DE AMONIACO */}
                    <div className="formulario-fields-column">
                        <label className="p-0 m-0 gris">DATOS DE BONIFICACIÓN POR USO DE AMONIACO</label>
                        <div className="formulario-field no-flex">
                            <label htmlFor="aplica_bonif_amoniaco" className="m-0">¿BONIFICACIÓN ACTIVA?</label>
                            <span >{item.aplica_bonif_amoniaco ? "SÍ": "NO"}</span>
                        </div>
                        <div className="formulario-field no-flex">
                            <label htmlFor="valor_limite_nh3" className="m-0">VALOR LÍMITE NH3</label>
                            <span >{configBonifAmoniaco.valor_limite_nh3}</span>
                        </div>
                        <div className="formulario-field no-flex">
                            <label htmlFor="bono_por_kilogramo" className="m-0">BONO POR KILOGRAMO</label>
                            <span >{currencyValue(configBonifAmoniaco.bono_por_kilogramo)}</span>
                        </div>
                    </div>

                    {/* BONIFICACION POR COSTO DE FLETES */}
                    <div className="formulario-fields-column">
                        <label className="p-0 m-0 gris">DATOS DE BONIFICACIÓN POR TRANSPORTE</label>
                        <div className="formulario-field no-flex">
                            <label htmlFor="aplica_bonif_fletes" className="m-0">¿BONIFICACIÓN ACTIVA?</label>
                            <span >{item.aplica_bonif_fletes ? "SÍ": "NO"}</span>
                        </div>
                        <div className="formulario-field">
                            <label htmlFor="valor_limite_nh3" className="m-0">KILOGRAMOS MÍNIMOS</label>
                            <span >{kgValue(configBonifFletes.bonif_fletes_min_kg)}</span>
                        </div>
                        <div className="formulario-field">
                            <label htmlFor="bono_por_kilogramo" className="m-0">BONO POR KILOGRAMO</label>
                            <span >{currencyValue(configBonifFletes.bonif_fletes_bono_por_kg)}</span>
                        </div>
                    </div>
                </div>
            </CardEmpty>
        </div>
    )
}

export default DatosBonificacion;
